import React, { useState } from 'react';
import Review from '../components/Review.jsx';

export default function ReviewPage() {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async ({ rating, comment }) => {
    setSubmitting(true);
    try {
      // TODO: wire to backend endpoint if desired
      console.log('Review submitted:', { rating, comment });
      alert('Thanks for your review!');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: 720, margin: '0 auto', padding: 16 }}>
      <h2 style={{ marginTop: 0 }}>Create a Review</h2>
      <Review onSubmit={handleSubmit} submitting={submitting} />
    </div>
  );
}

